import { createSlice } from '@reduxjs/toolkit';
import { CONFIGURATION_DIALOG_MODE } from '../constants';

const initialState = {
    httpRequest: {
        inProgress: false,
        error: false,
        type: '',
    },
    dialog: { open: false, mode: CONFIGURATION_DIALOG_MODE.NEW },

    webHookTypes: [
        {
            value: '2n',
            label: '2N',
        },
        {
            value: 'zenitel',
            label: 'Zenitel',
        },
        {
            value: 'other',
            label: 'Other',
        },
    ],
    selectedWebHookType: '',

    audioConfiguredCameras: [],
    filterCriteria: { text: '', webHookType: {} },
    filteredCameras: [],

    allLocations: [],
    monitoringObjects: [],
    monitoringObjectCameras: [],

    selectedLocation: '',
    selectedMonitoringObject: '',
    selectedCamera: '',
    extensionNumber: undefined,
    urlConfiguration: null,
    errorMessage: '',
    isWebHookActive: false,
};

const aiqEventTriggersConfigurationSlice = createSlice({
    name: 'aiqEventTriggersConfiguration',
    initialState,
    reducers: {
        requestStart(state, { payload }) {
            state.httpRequest.inProgress = true;
            state.httpRequest.error = false;
            state.httpRequest.type = payload;
        },
        requestError(state) {
            state.httpRequest.inProgress = false;
            state.httpRequest.error = true;
            state.httpRequest.type = '';
        },
        requestSucces(state) {
            state.httpRequest.inProgress = false;
            state.httpRequest.type = '';
        },

        setAllLocations(state, { payload: allLocations }) {
            state.allLocations = allLocations;
        },
        setMonitoringObjects(state, { payload: monitoringObjects }) {
            state.monitoringObjects = monitoringObjects;
        },

        setSelectedLocation(state, { payload: selectedLocation }) {
            state.selectedLocation = selectedLocation;
            state.selectedMonitoringObject = null;
            state.monitoringObjects = [];
            state.selectedCamera = null;
            state.monitoringObjectCameras = [];
            state.extensionNumber = undefined;
            state.urlConfiguration = undefined;
        },

        setSelectedMonitoringObject(state, { payload: selectedMonitoringObject }) {
            state.selectedMonitoringObject = { ...selectedMonitoringObject, label: selectedMonitoringObject.title };
            state.selectedCamera = null;
            state.monitoringObjectCameras = [];
            state.extensionNumber = undefined;
            state.urlConfiguration = undefined;
        },

        setSelectedCamera(state, { payload: selectedCamera }) {
            state.selectedCamera = selectedCamera;
            state.extensionNumber = undefined;
            state.urlConfiguration = undefined;
        },

        setSelectedWebHookType(state, { payload: selectedType }) {
            state.selectedWebHookType = selectedType;
            state.extensionNumber = undefined;
            state.urlConfiguration = undefined;
        },

        toggleWebHookActive(state, { payload: selectedValue }) {
            state.isWebHookActive = selectedValue;
        },

        setExtensionNumber(state, { payload }) {
            state.extensionNumber = payload.externalId;
            state.urlConfiguration = payload.url;
        },

        setMonitoringObjectCameras(state, { payload }) {
            state.monitoringObjectCameras = payload;
        },

        getMonitoringObjects(state) {
            state.monitoringObjects = [];
        },

        getMonitoringObjectCameras(state) {
            state.monitoringObjectCameras = [];
        },

        filterCameras(state) {
            const filterCriteria = state.filterCriteria;
            const filtered = state.audioConfiguredCameras.filter((record) => {
                let showRecord = false;

                if (filterCriteria.text) {
                    showRecord =
                        includesText(record.yardName, filterCriteria.text) ||
                        includesText(record.name, filterCriteria.text) ||
                        includesText(record.webHookType, filterCriteria.text) ||
                        includesText(record.id, filterCriteria.text) ||
                        includesText(record?.monitoringObjects?.[0]?.label, filterCriteria.text);
                } else showRecord = true;

                return showRecord;
            });
            const isFiltered = filtered.length !== state.filteredCameras.length;
            if (isFiltered) state.filteredCameras = filtered;
        },

        setConfiguredCameras(state, { payload }) {
            state.audioConfiguredCameras = payload;
            state.filteredCameras = payload;
        },

        setDialog(state, { payload: { open, mode } }) {
            state.dialog.open = open;
            state.dialog.mode = mode;
            if (!open) {
                state.dialog.mode = CONFIGURATION_DIALOG_MODE.NEW;
                state.selectedLocation = null;
                state.selectedMonitoringObject = null;
                state.monitoringObjects = [];
                state.selectedCamera = null;
                state.monitoringObjectCameras = [];
                state.extensionNumber = undefined;
                state.urlConfiguration = undefined;
                state.selectedWebHookType = '';
                state.isWebHookActive = '';
            }
        },

        setInitialState(state) {
            Object.keys(state).forEach((key) => {
                state[key] = initialState[key];
            });
        },

        setFilterCriteriaText(state, { payload: text }) {
            state.filterCriteria.text = text;
        },

        setErrorMessage(state, { payload }) {
            state.errorMessage = payload;
        },

        submitChanges() {},
        saveCameraConfiguration() {},
        openExistingRecord() {},
        getAllLocations() {},
        getConfiguredCameras() {},
        getInitialData() {},
        generateHandler() {},
    },
});

export const aiqEventTriggersConfigurationActions = aiqEventTriggersConfigurationSlice.actions;
export const aiqEventTriggersConfigurationReducer = aiqEventTriggersConfigurationSlice.reducer;
export const aiqEventTriggersConfigurationName = aiqEventTriggersConfigurationSlice.name;

//utils
const includesText = (field, criteria) => {
    return String(field).toLowerCase().includes(criteria.toLowerCase().replace(/\s+/g, ' ').trim());
};
